(function(global) {
  "use strict";

  var PFL_BROCHURE = "https://ff16c805-5612-464e-8d0e-3b4c9e7992d5.filesusr.com/ugd/424b96_e4eb6309321346deb2a755b0291931b0.pdf";
  var products = {
    "avant-garde-tiles-r10": { widths: [3, 4], source: "Phloor official product page" },
    "designer-tex-r11": { widths: [2, 4], source: "Current Shopify product content: Available Widths and ISO 24341" },
    "goliath": { widths: [3, 4], source: PFL_BROCHURE },
    "natura-tex": { widths: [3, 4], source: PFL_BROCHURE },
    "rhino-xl-tex": { widths: [3, 4], source: PFL_BROCHURE },
    "rhinotex": { widths: [3, 4], source: PFL_BROCHURE },
    "texstar": { widths: [3, 4], source: PFL_BROCHURE },
    "turbo-r10": { widths: [3, 4], source: "Phloor official current vinyl range listing" },
    "xtra-safe-r11": {
      widths: [3, 4],
      source: PFL_BROCHURE + " plus current Shopify variant titles",
      variantWidths: {
        "45393312317618": [4],
        "45393312350386": [3, 4],
        "45393312383154": [3, 4],
        "45393312415922": [2, 3, 4],
        "45393312448690": [3, 4],
        "45393312481458": [3, 4],
        "45393312514226": [3, 4]
      }
    }
  };

  function get(handle, variantId) {
    var record = products[String(handle || "")] || null;
    if (!record) return { widths: [], source: "missing_verified_width_evidence" };
    var variantWidths = record.variantWidths && record.variantWidths[String(variantId || "")];
    return {
      widths: (variantWidths || record.widths || []).slice(),
      source: record.source,
      variantSpecific: Boolean(variantWidths)
    };
  }

  global.ArraSheetVinylEvidence = { get: get };
  if (typeof global.dispatchEvent === "function" && typeof global.Event === "function") {
    global.dispatchEvent(new global.Event("af:sheet-vinyl-evidence-ready"));
  }
})(typeof window !== "undefined" ? window : globalThis);
